import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ArrowLeft, Shield } from 'lucide-react';

/**
 * Pulsante flottante per tornare alla lista negozi
 * Visibile SOLO quando un Platform Admin sta impersonando uno Store Admin
 */
export default function PlatformAdminBackButton() {
  const { user } = useAuth();
  const navigate = useNavigate();
  
  // Mostra solo se l'utente è Platform Admin e sta impersonando
  const isPlatformAdmin = user?.role === 'ADMIN_PLATFORM';
  const isImpersonating = localStorage.getItem('platform_admin_impersonating') === 'true';
  
  if (!isPlatformAdmin || !isImpersonating) {
    return null;
  }
  
  const handleBackToStores = () => {
    // Pulisci lo stato di impersonificazione
    localStorage.removeItem('platform_admin_impersonating');
    localStorage.removeItem('platform_admin_store_slug');
    localStorage.removeItem('storeSlug');
    
    // Torna alla pagina dei negozi
    navigate('/admin/platform');
  };
  
  return (
    <button
      onClick={handleBackToStores}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 px-4 py-3 rounded-full bg-gradient-to-r from-emerald-600 to-teal-600 text-white shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-200 group"
      data-testid="platform-admin-back-btn"
      title="Torna alla lista negozi"
    >
      <Shield className="w-5 h-5" />
      <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" />
      <span className="font-medium">Torna agli Shop</span>
    </button>
  );
}
